var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.other_postes.length>1)?_c('b-form-select',{staticClass:"form-select",attrs:{"options":_vm.other_postes},model:{value:(_vm.selectedPoste),callback:function ($$v) {_vm.selectedPoste=$$v},expression:"selectedPoste"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }